import {
  Tactic,
  TacticSortOptionValues,
} from "../../../redux/tactics/tacticsSlice";
import axios from "../../privateApi";

interface GetTactics {
  tacticSorting: TacticSortOptionValues;
  page: number;
  tacticLimit: number;
  author?: string;
  position?: string;
  formation?: string;
  allPositionsShouldBeIncluded?: boolean;
  isFavorite?: boolean;
}

export const getTactics = async ({
  tacticSorting,
  page,
  tacticLimit,
  author,
  position,
  formation,
  allPositionsShouldBeIncluded,
  isFavorite,
}: GetTactics): Promise<{
  totalPages: number;
  tactics: Tactic[];
}> => {
  const res = await axios.get<{
    totalPages: number;
    tactics: Tactic[];
  }>("/tactics", {
    params: {
      sort: tacticSorting,
      page,
      author,
      position,
      formation,
      "positions-all-selected": allPositionsShouldBeIncluded,
      limit: tacticLimit,
      favorites: isFavorite,
    },
  });
  return res.data;
};
